import PowerDate from '#metatypes/power_date.js'
import PowerBool from '#metatypes/power_bool.js'
import { define, type, auto, Record, Collection } from 'type-r'
import ConsentForm from './consent'
import SideEnum from '#metatypes/side_enum.js'

@define
export default class PtosisForm extends ConsentForm {
    @(type(SideEnum).required.as) side: string
}
